import React, { useEffect, useRef } from 'react';
import { Container } from '@pixi/react';
import { isMobile } from '../../../core/helpers/isMobile';

function ScaleComponent({
  children,
  isScaleToCenter,
  isBottom,
  isTop,
  isRight,
  isCenterVertical,
  isCenterHorizontal,
  margin = 0,
  name = '',
  positionX = 0,
  positionY = 0,
}) {
  const ref = useRef();

  useEffect(() => {
    if (!isMobile()) {
      return;
    }
    const scale = Math.min(window.innerWidth / 540, window.innerHeight / 960);
    ref.current.scale.set(scale);

    ref.current.x = positionX;

    ref.current.y = positionY;

    // if(scale < 1){
    //   return;
    // }

    if (isBottom) {
      ref.current.y = window.innerHeight - ref.current.height / 2 - margin;
    }

    if (isTop) {
      ref.current.y = ref.current.height / 2 + margin;
    }

    if (isCenterVertical) {
      ref.current.y = window.innerHeight / 2 - ref.current.height;
    }

    if (isCenterHorizontal) {
      ref.current.x = (window.innerWidth - ref.current.width) / 2;
    }
  }, [
    margin,
    isTop,
    isRight,
    positionX,
    positionY,
    isBottom,
    isScaleToCenter,
    isCenterVertical,
    isCenterHorizontal,
  ]);

  return (
    <Container ref={ref} name={name}>
      {children}
    </Container>
  );
}

export default ScaleComponent;
